export const PASS_HEIGHT = ['high', 'low', 'ground'];
